import styled from "styled-components";
import { flexColumn } from '../../styles/mixins.style';
import useScrollFadeIn from '../../hooks/useScrollFadeIn';
import { FadeInDiv } from '../../styles/fadeIn';

interface SubVisualProps {
  image: string;
  title: string;
  subtitle: React.ReactNode;
}

export default function SubVisual({ image, title, subtitle }: SubVisualProps) {
  const fadeText = useScrollFadeIn();
  return (
    <SubVisualWrapper>
      <SubVisualImg src={image} alt="서브 비주얼" />
      <FadeInDiv ref={fadeText.ref} $visible={fadeText.visible}>
        <SubVisualText>
          <SubVisualTitle>{title}</SubVisualTitle>
          <p>{subtitle}</p>
        </SubVisualText>
      </FadeInDiv>
    </SubVisualWrapper>
  );
}

const SubVisualWrapper = styled.div`
  ${flexColumn}
  width: 100%;
  height: 100vh;
  margin-bottom: 5rem;
  overflow: hidden;
  @media (max-width: 768px) {
    height: 100%;
  }
`;

const SubVisualImg = styled.img`
  max-width: 100%;
  width: 100%;
  height: 85vh;
  object-fit: cover;
  @media (max-width: 768px) {
    height: 60vh;
  }
`;

const SubVisualTitle = styled.span`
  display: block;
  font-family: 'MaruBuri', sans-serif;
  font-size: 1.5rem;
  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

const SubVisualText = styled.div`
  color: #fff;
  margin-top: 1.825rem;
  p {
    font-size: 1.125rem;
    font-weight: 400;
    margin-top: 1rem;
  }
  @media (max-width: 1024px) {
    margin-left: 1rem;
    text-align: center;
    p {
      font-size: 1rem;
      line-height: 1.625rem;
    }
  }
  @media (max-width: 768px) {
    margin: 2.5rem auto;
    width: 95%;
    p {
      margin-top: 0.5rem;
    }
  }
`;